import { render } from "./admin-logo-white.svg?vue&type=template&id=4971fabf"
const script = {}
script.render = render

export default script